[
  {
    "draftJersey": 1,
    "role": "DF",
    "name": "Jesús Paganoni",
    "foot": "right",
    "height": 170,
    "birthdate": "24/09/1988",
    "country": "MEX",
    "macros": {
      "physical": 82,
      "duels": 81,
      "shooting": 67,
      "defence": 85,
      "passing": 87,
      "skills": 83,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/001.jpg",
    "profileYtVideoId": "_FnaseVQ8Bo",
    "matchYtVideoId": "y_m3QK10K4M"
  },
  {
    "draftJersey": 3,
    "role": "MC",
    "name": "Alejandro Díaz",
    "foot": "right",
    "height": 169,
    "birthdate": "29/07/1999",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 71,
      "shooting": 58,
      "defence": 73,
      "passing": 78,
      "skills": 73,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/003.jpg",
    "profileYtVideoId": "KXSAP3LNt8g",
    "matchYtVideoId": "y_m3QK10K4M"
  },
  {
    "draftJersey": 5,
    "role": "DL",
    "name": "Andrés Guzmán",
    "foot": "right",
    "height": 183,
    "birthdate": "26/02/1999",
    "country": "MEX",
    "macros": {
      "physical": 73,
      "duels": 77,
      "shooting": 85,
      "defence": 66,
      "passing": 86,
      "skills": 77,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/005.jpg",
    "profileYtVideoId": "-FKVfHHonyw",
    "matchYtVideoId": "y_m3QK10K4M"
  },
  {
    "draftJersey": 6,
    "role": "DF",
    "name": "Patricio Arias",
    "foot": "right",
    "height": 180,
    "birthdate": "25/11/2003",
    "country": "MEX",
    "macros": {
      "physical": 89,
      "duels": 79,
      "shooting": 74,
      "defence": 82,
      "passing": 86,
      "skills": 81,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/006.jpg",
    "profileYtVideoId": "sIBGIZHUETQ",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 7,
    "role": "MC",
    "name": "Zaid Ramírez",
    "foot": "left",
    "height": 170,
    "birthdate": "26/01/2003",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 68,
      "shooting": 68,
      "defence": 58,
      "passing": 73,
      "skills": 66,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/007.jpg",
    "profileYtVideoId": "4_-5RQhrOAc",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 8,
    "role": "MC",
    "name": "Brihan Gutiérrez",
    "foot": "left",
    "height": 179,
    "birthdate": "02/12/1997",
    "country": "COL / MEX",
    "macros": {
      "physical": 83,
      "duels": 73,
      "shooting": 63,
      "defence": 68,
      "passing": 87,
      "skills": 74,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/008.jpg",
    "profileYtVideoId": "DgHjNXVVPX0",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 9,
    "role": "MC",
    "name": "Jesús Pérez",
    "foot": "right",
    "height": 171,
    "birthdate": "21/01/1997",
    "country": "MEX",
    "macros": {
      "physical": 74,
      "duels": 89,
      "shooting": 78,
      "defence": 65,
      "passing": 82,
      "skills": 90,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/009.jpg",
    "profileYtVideoId": "oW7-on_EB7o",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 12,
    "role": "MC",
    "name": "Edwin Cárdenas",
    "foot": "right",
    "height": 177,
    "birthdate": "21/03/2005",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 79,
      "shooting": 73,
      "defence": 67,
      "passing": 74,
      "skills": 79,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/012.jpg",
    "profileYtVideoId": "eypH6fQEa-s",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 13,
    "role": "MC",
    "name": "Rafael Aja",
    "foot": "left",
    "height": 172,
    "birthdate": "16/07/1994",
    "country": "MEX",
    "macros": {
      "physical": 81,
      "duels": 78,
      "shooting": 79,
      "defence": 76,
      "passing": 82,
      "skills": 80,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/013.jpg",
    "profileYtVideoId": "Mf6iAUx0vsA",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 14,
    "role": "MC",
    "name": "Donovan Martínez",
    "foot": "right",
    "height": 170,
    "birthdate": "21/02/1998",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 68,
      "shooting": 76,
      "defence": 85,
      "passing": 96,
      "skills": 70,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/014.jpg",
    "profileYtVideoId": "H7gPZIz2-SY",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 15,
    "role": "DL",
    "name": "Adolfo Valdez",
    "foot": "left",
    "height": 175,
    "birthdate": "11/01/2004",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 70,
      "shooting": 68,
      "defence": 66,
      "passing": 80,
      "skills": 70,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/015.jpg",
    "profileYtVideoId": "4ZrMAptPaFs",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 17,
    "role": "MC",
    "name": "Emiliano López",
    "foot": "right",
    "height": 163,
    "birthdate": "18/06/2004",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 70,
      "shooting": 65,
      "defence": 73,
      "passing": 81,
      "skills": 70,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/017.jpg",
    "profileYtVideoId": "1YAgjWVLwRk",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 18,
    "role": "MC",
    "name": "Gael Leyva",
    "foot": "right",
    "height": 175,
    "birthdate": "26/06/2002",
    "country": "MEX",
    "macros": {
      "physical": 71,
      "duels": 76,
      "shooting": 66,
      "defence": 64,
      "passing": 85,
      "skills": 76,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/018.jpg",
    "profileYtVideoId": "LyGMlymMGRk",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 19,
    "role": "MC",
    "name": "Samuel Rojas",
    "foot": "right",
    "height": 173,
    "birthdate": "30/09/2004",
    "country": "COL",
    "macros": {
      "physical": 75,
      "duels": 70,
      "shooting": 58,
      "defence": 64,
      "passing": 76,
      "skills": 70,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/019.jpg",
    "profileYtVideoId": "I6epjBr1H94",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 20,
    "role": "DL",
    "name": "Abner Rebollar",
    "foot": "right",
    "height": 174,
    "birthdate": "21/06/1993",
    "country": "MEX",
    "macros": {
      "physical": 86,
      "duels": 69,
      "shooting": 84,
      "defence": 78,
      "passing": 79,
      "skills": 71,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/020.jpg",
    "profileYtVideoId": "sqMFHNhBcec",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 22,
    "role": "MC",
    "name": "Didier Uribe",
    "foot": "right",
    "height": 172,
    "birthdate": "28/07/2004",
    "country": "MEX",
    "macros": {
      "physical": 83,
      "duels": 74,
      "shooting": 70,
      "defence": 80,
      "passing": 91,
      "skills": 76,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/022.jpg",
    "profileYtVideoId": "8BdbFgFxz2k",
    "matchYtVideoId": "mbhbzsUw1AA"
  },
  {
    "draftJersey": 23,
    "role": "MC",
    "name": "Juan Pablo Marín",
    "foot": "right",
    "height": 172,
    "birthdate": "03/08/1999",
    "country": "MEX / ESP",
    "macros": {
      "physical": 79,
      "duels": 83,
      "shooting": 68,
      "defence": 80,
      "passing": 82,
      "skills": 82,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/023.jpg",
    "profileYtVideoId": "oLNSGRaKtCM",
    "matchYtVideoId": "mbhbzsUw1AA"
  },
  {
    "draftJersey": 24,
    "role": "MC",
    "name": "Alejandro Aválos",
    "foot": "left",
    "height": 171,
    "birthdate": "08/05/1996",
    "country": "MEX",
    "macros": {
      "physical": 81,
      "duels": 71,
      "shooting": 70,
      "defence": 73,
      "passing": 73,
      "skills": 73,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/024.jpg",
    "profileYtVideoId": "rSCT-WfzmN0",
    "matchYtVideoId": "mbhbzsUw1AA"
  },
  {
    "draftJersey": 25,
    "role": "DL",
    "name": "Francisco García",
    "foot": "right",
    "height": 175,
    "birthdate": "19/07/1996",
    "country": "MEX / ESP",
    "macros": {
      "physical": 77,
      "duels": 61,
      "shooting": 70,
      "defence": 63,
      "passing": 74,
      "skills": 61,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/025.jpg",
    "profileYtVideoId": "fvFnFXJpxHE",
    "matchYtVideoId": "mbhbzsUw1AA"
  },
  {
    "draftJersey": 27,
    "role": "MC",
    "name": "Geovanni Sánchez",
    "foot": "left",
    "height": 174,
    "birthdate": "30/05/2002",
    "country": "MEX",
    "macros": {
      "physical": 74,
      "duels": 76,
      "shooting": 72,
      "defence": 68,
      "passing": 76,
      "skills": 77,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/027.jpg",
    "profileYtVideoId": "1y_22CKIAX4",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 29,
    "role": "MC",
    "name": "Julio García",
    "foot": "right",
    "height": 174,
    "birthdate": "20/2/1995",
    "country": "MEX",
    "macros": {
      "physical": 71,
      "duels": 64,
      "shooting": 73,
      "defence": 73,
      "passing": 80,
      "skills": 65,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/029.jpg",
    "profileYtVideoId": "KDcmMkUKnyA",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 30,
    "role": "DL",
    "name": "Miguel López",
    "foot": "right",
    "height": 185,
    "birthdate": "24/11/1992",
    "country": "MEX / USA",
    "macros": {
      "physical": 77,
      "duels": 63,
      "shooting": 73,
      "defence": 72,
      "passing": 91,
      "skills": 62,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/030.jpg",
    "profileYtVideoId": "5w1_bkHBmwk",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 31,
    "role": "DF",
    "name": "Juan Martínez",
    "foot": "right",
    "height": 188,
    "birthdate": "23/1/2000",
    "country": "MEX",
    "macros": {
      "physical": 85,
      "duels": 73,
      "shooting": 60,
      "defence": 78,
      "passing": 76,
      "skills": 73,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/031.jpg",
    "profileYtVideoId": "IUyNrE216JE",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 36,
    "role": "DF",
    "name": "Anferny Rebollar",
    "foot": "right",
    "height": 181,
    "birthdate": "03/12/1995",
    "country": "MEX",
    "macros": {
      "physical": 87,
      "duels": 75,
      "shooting": 67,
      "defence": 88,
      "passing": 77,
      "skills": 78,
      "average": 81
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/036.jpg",
    "profileYtVideoId": "D9M11czP3ck",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 40,
    "role": "DL",
    "name": "Alejandro García",
    "foot": "right",
    "height": 173,
    "birthdate": "31/01/1996",
    "country": "MEX",
    "macros": {
      "physical": 74,
      "duels": 67,
      "shooting": 68,
      "defence": 59,
      "passing": 80,
      "skills": 67,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/040.jpg",
    "profileYtVideoId": "qtTIJcSmv-4",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 42,
    "role": "MC",
    "name": "Rafael Monroy",
    "foot": "right",
    "height": 178,
    "birthdate": "25/5/1996",
    "country": "MEX",
    "macros": {
      "physical": 85,
      "duels": 74,
      "shooting": 58,
      "defence": 79,
      "passing": 72,
      "skills": 76,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/042.jpg",
    "profileYtVideoId": "IRIa2BtzCOo",
    "matchYtVideoId": "https://www.youtube.com/watch?v=r_n_Akrdb8w"
  },
  {
    "draftJersey": 43,
    "role": "MC",
    "name": "Cristian Chaparro",
    "foot": "right",
    "height": 178,
    "birthdate": "07/06/2002",
    "country": "MEX",
    "macros": {
      "physical": 85,
      "duels": 65,
      "shooting": 63,
      "defence": 76,
      "passing": 76,
      "skills": 67,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/043.jpg",
    "profileYtVideoId": "wCVfUqQzIGk",
    "matchYtVideoId": "https://www.youtube.com/watch?v=r_n_Akrdb8w"
  },
  {
    "draftJersey": 45,
    "role": "DL",
    "name": "Jacob Morales",
    "foot": "right",
    "height": 170,
    "birthdate": "22/03/1999",
    "country": "MEX",
    "macros": {
      "physical": 88,
      "duels": 76,
      "shooting": 81,
      "defence": 80,
      "passing": 79,
      "skills": 77,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/045.jpg",
    "profileYtVideoId": "My1OePWQh4w",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 47,
    "role": "MC",
    "name": "Cristopher Ayala",
    "foot": "right",
    "height": 171,
    "birthdate": "29/06/1998",
    "country": "MEX",
    "macros": {
      "physical": 73,
      "duels": 83,
      "shooting": 77,
      "defence": 60,
      "passing": 76,
      "skills": 82,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/047.jpg",
    "profileYtVideoId": "4Bhn_DF2kTU",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 50,
    "role": "DL",
    "name": "Luis Flores",
    "foot": "left",
    "height": 177,
    "birthdate": "20/11/1993",
    "country": "MEX",
    "macros": {
      "physical": 73,
      "duels": 64,
      "shooting": 66,
      "defence": 68,
      "passing": 80,
      "skills": 64,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/050.jpg",
    "profileYtVideoId": "O_oqfVZE2N8",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 51,
    "role": "DF",
    "name": "Osmar Mares",
    "foot": "left",
    "height": 169,
    "birthdate": "17/06/1987",
    "country": "MEX",
    "macros": {
      "physical": 83,
      "duels": 88,
      "shooting": 66,
      "defence": 91,
      "passing": 93,
      "skills": 91,
      "average": 86
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/051.jpg",
    "profileYtVideoId": "39wpaS8YSxQ",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 52,
    "role": "DL",
    "name": "Mauricio Garza",
    "foot": "right",
    "height": 183,
    "birthdate": "01/07/2002",
    "country": "MEX / USA",
    "macros": {
      "physical": 79,
      "duels": 67,
      "shooting": 78,
      "defence": 69,
      "passing": 76,
      "skills": 65,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/052.jpg",
    "profileYtVideoId": "Eqx6kPs4xno",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 54,
    "role": "MC",
    "name": "Asdrubal Arcos",
    "foot": "left",
    "height": 173,
    "birthdate": "23/8/1986",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 71,
      "shooting": 75,
      "defence": 68,
      "passing": 80,
      "skills": 73,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/054.jpg",
    "profileYtVideoId": "hpZDbpgqoWs",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 55,
    "role": "MC",
    "name": "Eder López",
    "foot": "right",
    "height": 172,
    "birthdate": "07/02/1991",
    "country": "MEX",
    "macros": {
      "physical": 81,
      "duels": 81,
      "shooting": 72,
      "defence": 82,
      "passing": 86,
      "skills": 83,
      "average": 81
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/055.jpg",
    "profileYtVideoId": "upJ4WtQlbhM",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 58,
    "role": "MC",
    "name": "Andrés Franco",
    "foot": "right",
    "height": 169,
    "birthdate": "05/09/1995",
    "country": "MEX / COL",
    "macros": {
      "physical": 70,
      "duels": 74,
      "shooting": 63,
      "defence": 63,
      "passing": 60,
      "skills": 73,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/058.jpg",
    "profileYtVideoId": "SbCjW5zh4K4",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 60,
    "role": "DL",
    "name": "José Rochín",
    "foot": "left",
    "height": 184,
    "birthdate": "28/4/1999",
    "country": "MEX",
    "macros": {
      "physical": 88,
      "duels": 81,
      "shooting": 75,
      "defence": 77,
      "passing": 73,
      "skills": 83,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/060.jpg",
    "profileYtVideoId": "NgYW5dsdywc",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 62,
    "role": "DL",
    "name": "Flavio Nogueira",
    "foot": "left",
    "height": 182,
    "birthdate": "17/02/1998",
    "country": "BRA / MEX",
    "macros": {
      "physical": 77,
      "duels": 61,
      "shooting": 69,
      "defence": 67,
      "passing": 74,
      "skills": 59,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/062.jpg",
    "profileYtVideoId": "w2g868jwWtw",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 64,
    "role": "MC",
    "name": "Alain Villanueva",
    "foot": "left",
    "height": 169,
    "birthdate": "28/03/1992",
    "country": "MEX / COL",
    "macros": {
      "physical": 83,
      "duels": 84,
      "shooting": 81,
      "defence": 82,
      "passing": 75,
      "skills": 86,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/064.jpg",
    "profileYtVideoId": "QpjnhuP7HWg",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 66,
    "role": "DF",
    "name": "Diego Sanjuan",
    "foot": "right",
    "height": 178,
    "birthdate": "06/04/1993",
    "country": "MEX / ESP",
    "macros": {
      "physical": 86,
      "duels": 76,
      "shooting": 69,
      "defence": 81,
      "passing": 76,
      "skills": 76,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/066.jpg",
    "profileYtVideoId": "zkrguawD9Hs",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 67,
    "role": "DL",
    "name": "Diego Gutiérrez",
    "foot": "right",
    "height": 176,
    "birthdate": "23/12/2001",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 70,
      "shooting": 61,
      "defence": 71,
      "passing": 77,
      "skills": 70,
      "average": 70
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/067.jpg",
    "profileYtVideoId": "vGB64vwPzlI",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 68,
    "role": "MC",
    "name": "Abner Monreal",
    "foot": "right",
    "height": 175,
    "birthdate": "06/04/2003",
    "country": "MEX",
    "macros": {
      "physical": 74,
      "duels": 75,
      "shooting": 61,
      "defence": 81,
      "passing": 77,
      "skills": 75,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/068.jpg",
    "profileYtVideoId": "I23BE4iWgRM",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 70,
    "role": "DL",
    "name": "Alejandro Vázquez",
    "foot": "right",
    "height": 163,
    "birthdate": "01/07/1994",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 79,
      "shooting": 66,
      "defence": 68,
      "passing": 69,
      "skills": 79,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/070.jpg",
    "profileYtVideoId": "KR5yFe3G7L4",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 71,
    "role": "DF",
    "name": "César García",
    "foot": "left",
    "height": 169,
    "birthdate": "09/04/2000",
    "country": "MEX",
    "macros": {
      "physical": 81,
      "duels": 81,
      "shooting": 66,
      "defence": 75,
      "passing": 73,
      "skills": 81,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/071.jpg",
    "profileYtVideoId": "3Ozbk-ac6O0",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 72,
    "role": "DF",
    "name": "Diego Castellanos",
    "foot": "right",
    "height": 176,
    "birthdate": "14/03/1993",
    "country": "MEX",
    "macros": {
      "physical": 85,
      "duels": 80,
      "shooting": 76,
      "defence": 81,
      "passing": 86,
      "skills": 79,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/072.jpg",
    "profileYtVideoId": "gUpUFw8SgNg",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 74,
    "role": "MC",
    "name": "Gerardo Lugo",
    "foot": "right",
    "height": 182,
    "birthdate": "31/12/1984",
    "country": "MEX / ESP",
    "macros": {
      "physical": 80,
      "duels": 83,
      "shooting": 74,
      "defence": 85,
      "passing": 97,
      "skills": 85,
      "average": 84
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/074.jpg",
    "profileYtVideoId": "nMOivg-QauM",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 76,
    "role": "DF",
    "name": "César Bernal",
    "foot": "right",
    "height": 172,
    "birthdate": "14/02/1995",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 83,
      "shooting": 87,
      "defence": 79,
      "passing": 83,
      "skills": 85,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/076.jpg",
    "profileYtVideoId": "eRzQmqJzpHE",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 77,
    "role": "DF",
    "name": "Luis Medina",
    "foot": "right",
    "height": 181,
    "birthdate": "07/12/2004",
    "country": "MEX",
    "macros": {
      "physical": 73,
      "duels": 73,
      "shooting": 71,
      "defence": 84,
      "passing": 79,
      "skills": 73,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/077.jpg",
    "profileYtVideoId": "ZUu0-3LmAnc",
    "matchYtVideoId": "F2tuem2DgKw"
  },
  {
    "draftJersey": 78,
    "role": "MC",
    "name": "Brayan Hernández",
    "foot": "right",
    "height": 173,
    "birthdate": "14/09/2000",
    "country": "MEX",
    "macros": {
      "physical": 89,
      "duels": 82,
      "shooting": 69,
      "defence": 71,
      "passing": 90,
      "skills": 83,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/078.jpg",
    "profileYtVideoId": "Oga_M11ozpM",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 83,
    "role": "MC",
    "name": "Daniel Ríos",
    "foot": "right",
    "height": 173,
    "birthdate": "02/05/1996",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 71,
      "shooting": 72,
      "defence": 77,
      "passing": 83,
      "skills": 70,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/083.jpg",
    "profileYtVideoId": "qFL-ACRWKf0",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 84,
    "role": "MC",
    "name": "Diego Franco",
    "foot": "left",
    "height": 178,
    "birthdate": "13/09/1992",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 71,
      "shooting": 70,
      "defence": 85,
      "passing": 78,
      "skills": 73,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/084.jpg",
    "profileYtVideoId": "xBLvexSYmJ0",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 85,
    "role": "DL",
    "name": "Josep Alonso",
    "foot": "right",
    "height": 180,
    "birthdate": "8/6/1996",
    "country": "ESP",
    "macros": {
      "physical": 79,
      "duels": 69,
      "shooting": 77,
      "defence": 87,
      "passing": 94,
      "skills": 71,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/085.jpg",
    "profileYtVideoId": "nWfrsCTZ1JI",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 87,
    "role": "DL",
    "name": "Héctor Hernández",
    "foot": "left",
    "height": 170,
    "birthdate": "30/10/2004",
    "country": "MEX",
    "macros": {
      "physical": 74,
      "duels": 69,
      "shooting": 62,
      "defence": 69,
      "passing": 70,
      "skills": 68,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/087.jpg",
    "profileYtVideoId": "2FyTEc2Umms",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 88,
    "role": "MC",
    "name": "Ian Granados",
    "foot": "right",
    "height": 173,
    "birthdate": "31/08/2002",
    "country": "MEX",
    "macros": {
      "physical": 70,
      "duels": 67,
      "shooting": 62,
      "defence": 74,
      "passing": 76,
      "skills": 65,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/088.jpg",
    "profileYtVideoId": "eNFbiwonCk8",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 89,
    "role": "MC",
    "name": "Alan Palomino",
    "foot": "right",
    "height": 168,
    "birthdate": "29/09/1998",
    "country": "MEX",
    "macros": {
      "physical": 75,
      "duels": 69,
      "shooting": 74,
      "defence": 77,
      "passing": 72,
      "skills": 68,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/089.jpg",
    "profileYtVideoId": "hDSOdmCD3qs",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 90,
    "role": "MC",
    "name": "Gustavo García",
    "foot": "left",
    "height": 181,
    "birthdate": "09/02/2003",
    "country": "MEX",
    "macros": {
      "physical": 78,
      "duels": 73,
      "shooting": 55,
      "defence": 84,
      "passing": 88,
      "skills": 73,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/090.jpg",
    "profileYtVideoId": "n5btx8E-4rI",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 91,
    "role": "DF",
    "name": "Miguel Cárdenas",
    "foot": "right",
    "height": 185,
    "birthdate": "28/12/2000",
    "country": "MEX / USA",
    "macros": {
      "physical": 71,
      "duels": 68,
      "shooting": 71,
      "defence": 63,
      "passing": 75,
      "skills": 66,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/091.jpg",
    "profileYtVideoId": "6nc-R3gjBbs",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 92,
    "role": "DL",
    "name": "Luis Juárez",
    "foot": "right",
    "height": 180,
    "birthdate": "09/04/1999",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 56,
      "shooting": 70,
      "defence": 68,
      "passing": 77,
      "skills": 56,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/092.jpg",
    "profileYtVideoId": "ZePJaWor8jQ",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 94,
    "role": "MC",
    "name": "Víctor Cuevas",
    "foot": "right",
    "height": 176,
    "birthdate": "08/06/2000",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 74,
      "shooting": 61,
      "defence": 73,
      "passing": 78,
      "skills": 76,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/094.jpg",
    "profileYtVideoId": "woEDcg8v8Dc",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 95,
    "role": "DL",
    "name": "Luis Romero",
    "foot": "right",
    "height": 176,
    "birthdate": "26/11/2004",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 76,
      "shooting": 70,
      "defence": 62,
      "passing": 80,
      "skills": 76,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/095.jpg",
    "profileYtVideoId": "9LD8go4EVno",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 97,
    "role": "MC",
    "name": "Iker Treviño",
    "foot": "left",
    "height": 187,
    "birthdate": "07/11/2002",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 74,
      "shooting": 75,
      "defence": 69,
      "passing": 84,
      "skills": 73,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/097.jpg",
    "profileYtVideoId": "O2EcIZ8HMBk",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 98,
    "role": "MC",
    "name": "Carlos Patiño",
    "foot": "right",
    "height": 180,
    "birthdate": "23/09/1984",
    "country": "MEX",
    "macros": {
      "physical": 70,
      "duels": 63,
      "shooting": 77,
      "defence": 63,
      "passing": 73,
      "skills": 62,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/098.jpg",
    "profileYtVideoId": "66tGZm2Rkik",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 99,
    "role": "MC",
    "name": "Axel Martínez",
    "foot": "right",
    "height": 180,
    "birthdate": "12/02/1997",
    "country": "MEX",
    "macros": {
      "physical": 82,
      "duels": 74,
      "shooting": 79,
      "defence": 87,
      "passing": 78,
      "skills": 76,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/099.jpg",
    "profileYtVideoId": "2-JhqJC7MEg",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 101,
    "role": "DF",
    "name": "Erik Vera",
    "foot": "left",
    "height": 170,
    "birthdate": "24/03/1992",
    "country": "MEX",
    "macros": {
      "physical": 81,
      "duels": 77,
      "shooting": 80,
      "defence": 85,
      "passing": 84,
      "skills": 80,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/101.jpg",
    "profileYtVideoId": "_yEpIHvhfbU",
    "matchYtVideoId": "F2tuem2DgKw"
  },
  {
    "draftJersey": 102,
    "role": "MC",
    "name": "Manuel Viniegra",
    "foot": "right",
    "height": 183,
    "birthdate": "26/04/1988",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 81,
      "shooting": 77,
      "defence": 82,
      "passing": 87,
      "skills": 83,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/102.jpg",
    "profileYtVideoId": "Qo8hsv6KR9w",
    "matchYtVideoId": "VGSRdaTy3Ao"
  },
  {
    "draftJersey": 105,
    "role": "DL",
    "name": "Martín Bravo",
    "foot": "right",
    "height": 168,
    "birthdate": "19/09/1986",
    "country": "ARG / MEX",
    "macros": {
      "physical": 78,
      "duels": 82,
      "shooting": 88,
      "defence": 65,
      "passing": 86,
      "skills": 83,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/2023/12/105.jpg",
    "profileYtVideoId": "5tM_q4ccq5k",
    "matchYtVideoId": "F2tuem2DgKw"
  },
  {
    "draftJersey": 107,
    "role": "MC",
    "name": "Alfonso Rosales",
    "foot": "right",
    "height": 160,
    "birthdate": "03/01/2004",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 82,
      "shooting": 66,
      "defence": 90,
      "passing": 86,
      "skills": 82,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/107.jpg",
    "profileYtVideoId": "Xk7eAxU-3Lk",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 108,
    "role": "MC",
    "name": "Iñaki Sánchez",
    "foot": "right",
    "height": 173,
    "birthdate": "18/08/1998",
    "country": "MEX / ESP",
    "macros": {
      "physical": 79,
      "duels": 70,
      "shooting": 79,
      "defence": 81,
      "passing": 70,
      "skills": 70,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/108.jpg",
    "profileYtVideoId": "PO_z2HtO2Hw",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 109,
    "role": "MC",
    "name": "César Romo",
    "foot": "right",
    "height": 175,
    "birthdate": "17/12/1995",
    "country": "MEX",
    "macros": {
      "physical": 84,
      "duels": 75,
      "shooting": 84,
      "defence": 79,
      "passing": 85,
      "skills": 77,
      "average": 81
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/109.jpg",
    "profileYtVideoId": "RQ_XVXoPhew",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 110,
    "role": "DL",
    "name": "Baruc Ochoa",
    "foot": "right",
    "height": 176,
    "birthdate": "13/7/2001",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 81,
      "shooting": 76,
      "defence": 79,
      "passing": 83,
      "skills": 83,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/110.jpg",
    "profileYtVideoId": "uCwKOo9KeCs",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 111,
    "role": "DF",
    "name": "Francisco García",
    "foot": "right",
    "height": 169,
    "birthdate": "08/01/2001",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 75,
      "shooting": 58,
      "defence": 76,
      "passing": 73,
      "skills": 75,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/111.jpg",
    "profileYtVideoId": "OdLx7cPaleA",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 112,
    "role": "MC",
    "name": "Juan Lozano",
    "foot": "right",
    "height": 178,
    "birthdate": "22/07/1999",
    "country": "MEX",
    "macros": {
      "physical": 77,
      "duels": 73,
      "shooting": 63,
      "defence": 73,
      "passing": 84,
      "skills": 73,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/112.jpg",
    "profileYtVideoId": "0NI67_0jBL0",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 114,
    "role": "MC",
    "name": "William Rojas",
    "foot": "right",
    "height": 170,
    "birthdate": "02/06/1989",
    "country": "COL",
    "macros": {
      "physical": 80,
      "duels": 70,
      "shooting": 74,
      "defence": 76,
      "passing": 82,
      "skills": 70,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/114.jpg",
    "profileYtVideoId": "8OLnzCQn8Qw",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 116,
    "role": "DF",
    "name": "Ramsey Evangelista",
    "foot": "left",
    "height": 175,
    "birthdate": "18/02/2000",
    "country": "MEX / USA",
    "macros": {
      "physical": 73,
      "duels": 66,
      "shooting": 64,
      "defence": 71,
      "passing": 85,
      "skills": 64,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/116.jpg",
    "profileYtVideoId": "LnVeWARZsVI",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 117,
    "role": "MC",
    "name": "José Rodríguez",
    "foot": "right",
    "height": 170,
    "birthdate": "20/11/1997",
    "country": "MEX",
    "macros": {
      "physical": 78,
      "duels": 72,
      "shooting": 79,
      "defence": 78,
      "passing": 71,
      "skills": 72,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/117.jpg",
    "profileYtVideoId": "cEocLT35FwA",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 119,
    "role": "MC",
    "name": "Adrián Monroy",
    "foot": "left",
    "height": 175,
    "birthdate": "24/05/2003",
    "country": "MEX",
    "macros": {
      "physical": 77,
      "duels": 71,
      "shooting": 65,
      "defence": 75,
      "passing": 78,
      "skills": 71,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/119.jpg",
    "profileYtVideoId": "tdL7aJQOHYk",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 120,
    "role": "DL",
    "name": "Irving Ortiz",
    "foot": "right",
    "height": 183,
    "birthdate": "14/03/1998",
    "country": "MEX",
    "macros": {
      "physical": 83,
      "duels": 71,
      "shooting": 74,
      "defence": 69,
      "passing": 73,
      "skills": 69,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/120.jpg",
    "profileYtVideoId": "rnkQVxpH98M",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 121,
    "role": "DF",
    "name": "Jorge Ross",
    "foot": "left",
    "height": 177,
    "birthdate": "09/05/1996",
    "country": "MEX",
    "macros": {
      "physical": 77,
      "duels": 63,
      "shooting": 69,
      "defence": 67,
      "passing": 73,
      "skills": 64,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/121.jpg",
    "profileYtVideoId": "l_xczi2FgJ4",
    "matchYtVideoId": "VGSRdaTy3Ao"
  },
  {
    "draftJersey": 123,
    "role": "MC",
    "name": "Bruno Sánchez",
    "foot": "right",
    "height": 177,
    "birthdate": "16/10/2004",
    "country": "ARG / MEX",
    "macros": {
      "physical": 77,
      "duels": 71,
      "shooting": 65,
      "defence": 73,
      "passing": 75,
      "skills": 71,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/123.jpg",
    "profileYtVideoId": "MAvtMDAIpo8",
    "matchYtVideoId": "VGSRdaTy3Ao"
  },
  {
    "draftJersey": 126,
    "role": "DF",
    "name": "Jorge Ruiz",
    "foot": "left",
    "height": 175,
    "birthdate": "13/11/1993",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 65,
      "shooting": 74,
      "defence": 70,
      "passing": 82,
      "skills": 66,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/126.jpg",
    "profileYtVideoId": "BYSAv3kjXGU",
    "matchYtVideoId": "https://www.youtube.com/watch?v=y_m3QK10K4M"
  },
  {
    "draftJersey": 129,
    "role": "DL",
    "name": "David González",
    "foot": "left",
    "height": 172,
    "birthdate": "10/07/1998",
    "country": "MEX",
    "macros": {
      "physical": 77,
      "duels": 62,
      "shooting": 65,
      "defence": 68,
      "passing": 77,
      "skills": 64,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/129.jpg",
    "profileYtVideoId": "R9BF7R2r0mw",
    "matchYtVideoId": "https://www.youtube.com/watch?v=y_m3QK10K4M"
  },
  {
    "draftJersey": 131,
    "role": "DF",
    "name": "Carlos Salazar",
    "foot": "left",
    "height": 182,
    "birthdate": "15/06/1999",
    "country": "MEX",
    "macros": {
      "physical": 77,
      "duels": 75,
      "shooting": 71,
      "defence": 80,
      "passing": 85,
      "skills": 74,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/131.jpg",
    "profileYtVideoId": "B6YrR6EyoLY",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 132,
    "role": "MC",
    "name": "Ricardo Villavicencio",
    "foot": "right",
    "height": 179,
    "birthdate": "18/05/2001",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 73,
      "shooting": 64,
      "defence": 70,
      "passing": 87,
      "skills": 74,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/132.jpg",
    "profileYtVideoId": "0w9UEMhTQRk",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 133,
    "role": "MC",
    "name": "Santiago Lagarde",
    "foot": "left",
    "height": 177,
    "birthdate": "06/03/1996",
    "country": "MEX",
    "macros": {
      "physical": 84,
      "duels": 76,
      "shooting": 79,
      "defence": 85,
      "passing": 90,
      "skills": 77,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/133.jpg",
    "profileYtVideoId": "y9buK5nr2jo",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 134,
    "role": "DL",
    "name": "Alan Calderón",
    "foot": "right",
    "height": 163,
    "birthdate": "17/06/1994",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 73,
      "shooting": 68,
      "defence": 64,
      "passing": 87,
      "skills": 71,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/134.jpg",
    "profileYtVideoId": "OUbAMhVMsgo",
    "matchYtVideoId": "JO65Jz0LrNU"
  },
  {
    "draftJersey": 137,
    "role": "MC",
    "name": "Kevin Quiñones",
    "foot": "left",
    "height": 170,
    "birthdate": "30/04/1992",
    "country": "MEX",
    "macros": {
      "physical": 81,
      "duels": 65,
      "shooting": 69,
      "defence": 82,
      "passing": 86,
      "skills": 67,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/137.jpg",
    "profileYtVideoId": "vE3zHSIfqrc",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 139,
    "role": "DL",
    "name": "Ismael Valadez",
    "foot": "right",
    "height": 180,
    "birthdate": "14/09/1985",
    "country": "MEX",
    "macros": {
      "physical": 90,
      "duels": 75,
      "shooting": 63,
      "defence": 81,
      "passing": 79,
      "skills": 77,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/139.jpg",
    "profileYtVideoId": "pLx62l6EvAg",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 140,
    "role": "DL",
    "name": "Kevin Jiménez",
    "foot": "right",
    "height": 165,
    "birthdate": "16/05/2001",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 64,
      "shooting": 70,
      "defence": 61,
      "passing": 83,
      "skills": 62,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/140.jpg",
    "profileYtVideoId": "3xZdsKC7ljA",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 141,
    "role": "DF",
    "name": "Alejandro Cortés",
    "foot": "left",
    "height": 182,
    "birthdate": "11/01/2005",
    "country": "MEX",
    "macros": {
      "physical": 75,
      "duels": 66,
      "shooting": 74,
      "defence": 71,
      "passing": 88,
      "skills": 64,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/141.jpg",
    "profileYtVideoId": "4SSc6U7ZfYQ",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 143,
    "role": "MC",
    "name": "Juan Suárez",
    "foot": "right",
    "height": 170,
    "birthdate": "20/07/1998",
    "country": "MEX",
    "macros": {
      "physical": 78,
      "duels": 74,
      "shooting": 68,
      "defence": 73,
      "passing": 81,
      "skills": 74,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/143.jpg",
    "profileYtVideoId": "b2mIpspoNoA",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 144,
    "role": "DL",
    "name": "Juan Olvera",
    "foot": "right",
    "height": 183,
    "birthdate": "13/11/1998",
    "country": "USA / MEX",
    "macros": {
      "physical": 87,
      "duels": 81,
      "shooting": 82,
      "defence": 79,
      "passing": 85,
      "skills": 83,
      "average": 83
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/144.jpg",
    "profileYtVideoId": "xORjNgki_QE",
    "matchYtVideoId": "https://www.youtube.com/watch?v=y_m3QK10K4M"
  },
  {
    "draftJersey": 145,
    "role": "DL",
    "name": "Cristian Cortés",
    "foot": "right",
    "height": 182,
    "birthdate": "17/03/1999",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 76,
      "shooting": 69,
      "defence": 72,
      "passing": 82,
      "skills": 76,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/145.jpg",
    "profileYtVideoId": "aGBspcFkhk4",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 147,
    "role": "MC",
    "name": "Rafael González",
    "foot": "left",
    "height": 179,
    "birthdate": "19/01/1998",
    "country": "MEX / ESP",
    "macros": {
      "physical": 75,
      "duels": 67,
      "shooting": 74,
      "defence": 67,
      "passing": 81,
      "skills": 67,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/147.jpg",
    "profileYtVideoId": "BygYoSohP2g",
    "matchYtVideoId": "Wc4WvJwgVNQ"
  },
  {
    "draftJersey": 148,
    "role": "MC",
    "name": "Juan Pulido",
    "foot": "right",
    "height": 180,
    "birthdate": "24/01/1999",
    "country": "MEX",
    "macros": {
      "physical": 77,
      "duels": 78,
      "shooting": 69,
      "defence": 72,
      "passing": 82,
      "skills": 78,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/148.jpg",
    "profileYtVideoId": "L3czXcmePS8",
    "matchYtVideoId": "https://www.youtube.com/watch?v=mbhbzsUw1AA"
  },
  {
    "draftJersey": 149,
    "role": "DL",
    "name": "Julio Espinoza",
    "foot": "right",
    "height": 180,
    "birthdate": "03/12/1999",
    "country": "MEX / ESP",
    "macros": {
      "physical": 73,
      "duels": 67,
      "shooting": 75,
      "defence": 67,
      "passing": 72,
      "skills": 67,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/149.jpg",
    "profileYtVideoId": "EV8zMavYfzs",
    "matchYtVideoId": "https://www.youtube.com/watch?v=mbhbzsUw1AA"
  },
  {
    "draftJersey": 152,
    "role": "MC",
    "name": "Iñaki Domínguez",
    "foot": "right",
    "height": 179,
    "birthdate": "30/03/1994",
    "country": "MEX / ESP",
    "macros": {
      "physical": 79,
      "duels": 70,
      "shooting": 62,
      "defence": 78,
      "passing": 88,
      "skills": 70,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/152.jpg",
    "profileYtVideoId": "sV76i2BnSxg",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 154,
    "role": "DL",
    "name": "Diego Vivian",
    "foot": "right",
    "height": 175,
    "birthdate": "10/12/1997",
    "country": "MEX / ESP",
    "macros": {
      "physical": 82,
      "duels": 76,
      "shooting": 72,
      "defence": 74,
      "passing": 84,
      "skills": 76,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/154.jpg",
    "profileYtVideoId": "DPTeKl6gzJ4",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 155,
    "role": "DL",
    "name": "Isaac Atilano",
    "foot": "right",
    "height": 175,
    "birthdate": "16/11/2002",
    "country": "MEX",
    "macros": {
      "physical": 82,
      "duels": 63,
      "shooting": 69,
      "defence": 84,
      "passing": 83,
      "skills": 62,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/155.jpg",
    "profileYtVideoId": "c-hU4y7uf3I",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 159,
    "role": "DL",
    "name": "Juan Hernández",
    "foot": "left",
    "height": 174,
    "birthdate": "05/01/1986",
    "country": "MEX",
    "macros": {
      "physical": 84,
      "duels": 64,
      "shooting": 70,
      "defence": 79,
      "passing": 80,
      "skills": 64,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/159.jpg",
    "profileYtVideoId": "eBKbIX9SJOM",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 161,
    "role": "DF",
    "name": "César Marín",
    "foot": "right",
    "height": 179,
    "birthdate": "01/07/1998",
    "country": "MEX",
    "macros": {
      "physical": 75,
      "duels": 71,
      "shooting": 57,
      "defence": 77,
      "passing": 82,
      "skills": 71,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/161.jpg",
    "profileYtVideoId": "LCl9qMiroLk",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 163,
    "role": "MC",
    "name": "Jonathan Canto",
    "foot": "left",
    "height": 181,
    "birthdate": "02/01/2001",
    "country": "DNK / MEX",
    "macros": {
      "physical": 78,
      "duels": 71,
      "shooting": 63,
      "defence": 78,
      "passing": 80,
      "skills": 71,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/163.jpg",
    "profileYtVideoId": "GC7uNF-hDLY",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 165,
    "role": "DL",
    "name": "Rubén Ruiz",
    "foot": "right",
    "height": 175,
    "birthdate": "09/05/1993",
    "country": "MEX",
    "macros": {
      "physical": 73,
      "duels": 73,
      "shooting": 65,
      "defence": 71,
      "passing": 63,
      "skills": 73,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/165.jpg",
    "profileYtVideoId": "NCQhPOaNdHQ",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 167,
    "role": "MC",
    "name": "Jairo Tapie",
    "foot": "right",
    "height": 164,
    "birthdate": "22/09/1991",
    "country": "COL / MEX",
    "macros": {
      "physical": 81,
      "duels": 59,
      "shooting": 71,
      "defence": 82,
      "passing": 89,
      "skills": 61,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/167.jpg",
    "profileYtVideoId": "NGIsIWSs4Tc",
    "matchYtVideoId": "https://www.youtube.com/watch?v=r_n_Akrdb8w"
  },
  {
    "draftJersey": 169,
    "role": "DL",
    "name": "Dustin Salazar",
    "foot": "right",
    "height": 165,
    "birthdate": "22/12/2000",
    "country": "MEX",
    "macros": {
      "physical": 85,
      "duels": 67,
      "shooting": 73,
      "defence": 66,
      "passing": 82,
      "skills": 67,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/169.jpg",
    "profileYtVideoId": "jbDEOXOADAQ",
    "matchYtVideoId": "https://www.youtube.com/watch?v=r_n_Akrdb8w"
  },
  {
    "draftJersey": 171,
    "role": "DF",
    "name": "Gustavo Lua",
    "foot": "right",
    "height": 186,
    "birthdate": "24/02/1990",
    "country": "MEX",
    "macros": {
      "physical": 84,
      "duels": 73,
      "shooting": 71,
      "defence": 75,
      "passing": 80,
      "skills": 74,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/171.jpg",
    "profileYtVideoId": "ktgRewh0tmc",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 172,
    "role": "MC",
    "name": "César Kuri",
    "foot": "left",
    "height": 170,
    "birthdate": "09/11/1993",
    "country": "MEX",
    "macros": {
      "physical": 70,
      "duels": 65,
      "shooting": 60,
      "defence": 65,
      "passing": 76,
      "skills": 63,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/172.jpg",
    "profileYtVideoId": "9A3vdNl_Lcw",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 173,
    "role": "MC",
    "name": "Alfredo Fierro",
    "foot": "right",
    "height": 170,
    "birthdate": "29/05/2004",
    "country": "MEX",
    "macros": {
      "physical": 86,
      "duels": 72,
      "shooting": 61,
      "defence": 70,
      "passing": 73,
      "skills": 72,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/173.jpg",
    "profileYtVideoId": "utdRAUgs9hA",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 175,
    "role": "DL",
    "name": "Kevin Olivares",
    "foot": "right",
    "height": 165,
    "birthdate": "12/08/1997",
    "country": "MEX",
    "macros": {
      "physical": 92,
      "duels": 67,
      "shooting": 59,
      "defence": 74,
      "passing": 76,
      "skills": 65,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/175.jpg",
    "profileYtVideoId": "ntxFnq8Czvs",
    "matchYtVideoId": "AjkPh6mIRZs"
  },
  {
    "draftJersey": 176,
    "role": "DF",
    "name": "Diego Flores",
    "foot": "right",
    "height": 180,
    "birthdate": "27/8/2005",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 69,
      "shooting": 71,
      "defence": 60,
      "passing": 72,
      "skills": 68,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/176.jpg",
    "profileYtVideoId": "pcr4rrJwq4M",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 177,
    "role": "MC",
    "name": "Querubín Romero",
    "foot": "left",
    "height": 175,
    "birthdate": "11/09/1988",
    "country": "USA",
    "macros": {
      "physical": 74,
      "duels": 61,
      "shooting": 63,
      "defence": 73,
      "passing": 73,
      "skills": 61,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/177.jpg",
    "profileYtVideoId": "iGrAl7lNZtI",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 178,
    "role": "MC",
    "name": "Miguel Espinosa",
    "foot": "right",
    "height": 174,
    "birthdate": "01/06/1996",
    "country": "COL",
    "macros": {
      "physical": 74,
      "duels": 66,
      "shooting": 68,
      "defence": 68,
      "passing": 67,
      "skills": 64,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/178.jpg",
    "profileYtVideoId": "zNeZGlrJ7M8",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 179,
    "role": "DL",
    "name": "Cristian Gómez",
    "foot": "right",
    "height": 167,
    "birthdate": "09/02/1993",
    "country": "COL / MEX",
    "macros": {
      "physical": 74,
      "duels": 52,
      "shooting": 63,
      "defence": 77,
      "passing": 60,
      "skills": 50,
      "average": 62
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/179.jpg",
    "profileYtVideoId": "eAxL3C1oMiw",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 180,
    "role": "DL",
    "name": "Erick Cerda",
    "foot": "left",
    "height": 170,
    "birthdate": "19/12/1998",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 65,
      "shooting": 67,
      "defence": 71,
      "passing": 72,
      "skills": 64,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/180.jpg",
    "profileYtVideoId": "2cHEnhsDDB4",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 181,
    "role": "DF",
    "name": "Martín Pureco",
    "foot": "left",
    "height": 183,
    "birthdate": "15/05/1992",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 58,
      "shooting": 65,
      "defence": 74,
      "passing": 79,
      "skills": 57,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/181.jpg",
    "profileYtVideoId": "9IJ2RKo1uWY",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 182,
    "role": "MC",
    "name": "Martín Rodríguez",
    "foot": "right",
    "height": 176,
    "birthdate": "18/05/1998",
    "country": "MEX",
    "macros": {
      "physical": 82,
      "duels": 77,
      "shooting": 83,
      "defence": 94,
      "passing": 78,
      "skills": 79,
      "average": 82
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/182.jpg",
    "profileYtVideoId": "RcHvUDuhXWU",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 183,
    "role": "MC",
    "name": "Roberto Medrano",
    "foot": "right",
    "height": 167,
    "birthdate": "01/07/2005",
    "country": "BOL",
    "macros": {
      "physical": 73,
      "duels": 67,
      "shooting": 66,
      "defence": 68,
      "passing": 83,
      "skills": 65,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/183.jpg",
    "profileYtVideoId": "Nm0IT4a2RtU",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 185,
    "role": "DL",
    "name": "Sergio Vázquez del Mercado",
    "foot": "right",
    "height": 174,
    "birthdate": "25/04/2001",
    "country": "MEX",
    "macros": {
      "physical": 86,
      "duels": 62,
      "shooting": 74,
      "defence": 72,
      "passing": 66,
      "skills": 60,
      "average": 70
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/185.jpg",
    "profileYtVideoId": "oe_muCzCkYw",
    "matchYtVideoId": "yo8BloHgpLo"
  },
  {
    "draftJersey": 189,
    "role": "DL",
    "name": "José Nieto",
    "foot": "right",
    "height": 180,
    "birthdate": "31/10/1991",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 77,
      "shooting": 75,
      "defence": 79,
      "passing": 71,
      "skills": 78,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/189.jpg",
    "profileYtVideoId": "H6sVyhzAlvk",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 190,
    "role": "DL",
    "name": "Josué Perea",
    "foot": "right",
    "height": 184,
    "birthdate": "23/03/1990",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 68,
      "shooting": 57,
      "defence": 64,
      "passing": 80,
      "skills": 67,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/190.jpg",
    "profileYtVideoId": "g6IsTMunAp4",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 191,
    "role": "DF",
    "name": "Nicolás Jalil",
    "foot": "right",
    "height": 180,
    "birthdate": "08/10/1992",
    "country": "ARG / MEX",
    "macros": {
      "physical": 84,
      "duels": 67,
      "shooting": 77,
      "defence": 79,
      "passing": 74,
      "skills": 68,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/191.jpg",
    "profileYtVideoId": "HUyL3V5Eps0",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 192,
    "role": "MC",
    "name": "Christopher Pedraza",
    "foot": "left",
    "height": 178,
    "birthdate": "23/11/1998",
    "country": "MEX",
    "macros": {
      "physical": 85,
      "duels": 77,
      "shooting": 75,
      "defence": 80,
      "passing": 90,
      "skills": 75,
      "average": 81
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/192.jpg",
    "profileYtVideoId": "f1VTYl95OvQ",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 197,
    "role": "MC",
    "name": "José Islas",
    "foot": "right",
    "height": 183,
    "birthdate": "21/09/2000",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 74,
      "shooting": 83,
      "defence": 70,
      "passing": 88,
      "skills": 74,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/197.jpg",
    "profileYtVideoId": "wzZYFqakP-4",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 199,
    "role": "DL",
    "name": "Ricardo Bernal",
    "foot": "left",
    "height": 185,
    "birthdate": "25/05/1991",
    "country": "MEX",
    "macros": {
      "physical": 70,
      "duels": 72,
      "shooting": 62,
      "defence": 64,
      "passing": 77,
      "skills": 72,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/199.jpg",
    "profileYtVideoId": "uNxAAWgRX8Q",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 200,
    "role": "DL",
    "name": "Luis Robles",
    "foot": "right",
    "height": 170,
    "birthdate": "17/03/1999",
    "country": "MEX",
    "macros": {
      "physical": 82,
      "duels": 79,
      "shooting": 77,
      "defence": 81,
      "passing": 87,
      "skills": 79,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/200.jpg",
    "profileYtVideoId": "EBEERV_0FsE",
    "matchYtVideoId": "dj8UXeT10TQ"
  },
  {
    "draftJersey": 201,
    "role": "DF",
    "name": "Carlos Valencia",
    "foot": "right",
    "height": 170,
    "birthdate": "4/4/2000",
    "country": "MEX",
    "macros": {
      "physical": 75,
      "duels": 57,
      "shooting": 69,
      "defence": 68,
      "passing": 83,
      "skills": 59,
      "average": 70
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/201.jpg",
    "profileYtVideoId": "a40eH6O17oY",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 203,
    "role": "MC",
    "name": "Yair Arias",
    "foot": "right",
    "height": 165,
    "birthdate": "21/01/2000",
    "country": "COL",
    "macros": {
      "physical": 88,
      "duels": 72,
      "shooting": 66,
      "defence": 79,
      "passing": 86,
      "skills": 74,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/203.jpg",
    "profileYtVideoId": "NQo4o6gprCg",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 204,
    "role": "DL",
    "name": "Luis Ahumada",
    "foot": "right",
    "height": 180,
    "birthdate": "10/04/2003",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 63,
      "shooting": 62,
      "defence": 67,
      "passing": 85,
      "skills": 65,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/204.jpg",
    "profileYtVideoId": "a64yZHhSWLg",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 205,
    "role": "DL",
    "name": "Gabriel Morales",
    "foot": "left",
    "height": 185,
    "birthdate": "9/11/2000",
    "country": "MEX",
    "macros": {
      "physical": 77,
      "duels": 67,
      "shooting": 71,
      "defence": 65,
      "passing": 85,
      "skills": 67,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/205.jpg",
    "profileYtVideoId": "JaRIwwyn2tI",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 207,
    "role": "MC",
    "name": "Diego Ibáñez",
    "foot": "left",
    "height": 179,
    "birthdate": "22/02/2000",
    "country": "MEX / ESP",
    "macros": {
      "physical": 75,
      "duels": 68,
      "shooting": 58,
      "defence": 67,
      "passing": 72,
      "skills": 68,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/207.jpg",
    "profileYtVideoId": "KCZxMkLNUGM",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 208,
    "role": "MC",
    "name": "Marlon Martínez",
    "foot": "right",
    "height": 177,
    "birthdate": "02/01/2003",
    "country": "MEX",
    "macros": {
      "physical": 78,
      "duels": 60,
      "shooting": 59,
      "defence": 70,
      "passing": 78,
      "skills": 60,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/208.jpg",
    "profileYtVideoId": "NqhohlD7-C8",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 211,
    "role": "DF",
    "name": "Rafael Martínez",
    "foot": "right",
    "height": 184,
    "birthdate": "03/06/1995",
    "country": "MEX / ESP",
    "macros": {
      "physical": 85,
      "duels": 68,
      "shooting": 71,
      "defence": 74,
      "passing": 81,
      "skills": 66,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/211.jpg",
    "profileYtVideoId": "jYEcn3SgiOo",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 212,
    "role": "MC",
    "name": "César Villaluz",
    "foot": "right",
    "height": 170,
    "birthdate": "18/07/1988",
    "country": "MEX",
    "macros": {
      "physical": 78,
      "duels": 80,
      "shooting": 81,
      "defence": 76,
      "passing": 75,
      "skills": 82,
      "average": 79
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/212.jpg",
    "profileYtVideoId": "27LOh1JViVo",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 215,
    "role": "DL",
    "name": "Mario Sánchez",
    "foot": "left",
    "height": 179,
    "birthdate": "14/09/2002",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 67,
      "shooting": 69,
      "defence": 72,
      "passing": 67,
      "skills": 65,
      "average": 70
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/215.jpg",
    "profileYtVideoId": "kX3uyXVm2hc",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 217,
    "role": "MC",
    "name": "Felipe Jiménez",
    "foot": "right",
    "height": 182,
    "birthdate": "21/09/2000",
    "country": "COL",
    "macros": {
      "physical": 80,
      "duels": 66,
      "shooting": 65,
      "defence": 78,
      "passing": 79,
      "skills": 66,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/217.jpg",
    "profileYtVideoId": "FcR6KdGfZUg",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 218,
    "role": "MC",
    "name": "Edson Trejo",
    "foot": "right",
    "height": 180,
    "birthdate": "31/12/2000",
    "country": "MEX",
    "macros": {
      "physical": 74,
      "duels": 69,
      "shooting": 84,
      "defence": 79,
      "passing": 80,
      "skills": 71,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/218.jpg",
    "profileYtVideoId": "Uvn5oTOfV94",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 220,
    "role": "DL",
    "name": "Juan Garza",
    "foot": "right",
    "height": 177,
    "birthdate": "05/08/2003",
    "country": "MEX",
    "macros": {
      "physical": 88,
      "duels": 68,
      "shooting": 68,
      "defence": 85,
      "passing": 85,
      "skills": 68,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/220.jpg",
    "profileYtVideoId": "8-vOGzviwjQ",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 221,
    "role": "DF",
    "name": "Mauricio Palomino",
    "foot": "right",
    "height": 170,
    "birthdate": "01/12/1997",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 72,
      "shooting": 65,
      "defence": 77,
      "passing": 70,
      "skills": 74,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/221.jpg",
    "profileYtVideoId": "O58k9zQ3Lew",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 222,
    "role": "MC",
    "name": "Pablo Sámano",
    "foot": "left",
    "height": 172,
    "birthdate": "01/05/2005",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 70,
      "shooting": 74,
      "defence": 81,
      "passing": 91,
      "skills": 70,
      "average": 78
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/222.jpg",
    "profileYtVideoId": "iX48FyarmEM",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 223,
    "role": "MC",
    "name": "Braulio Cerda",
    "foot": "right",
    "height": 176,
    "birthdate": "04/10/2002",
    "country": "MEX / USA",
    "macros": {
      "physical": 76,
      "duels": 64,
      "shooting": 63,
      "defence": 70,
      "passing": 71,
      "skills": 64,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/223.jpg",
    "profileYtVideoId": "ZFJQ_GVZ9UU",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 224,
    "role": "DL",
    "name": "Jorge León",
    "foot": "right",
    "height": 170,
    "birthdate": "29/01/1980",
    "country": "MEX",
    "macros": {
      "physical": 79,
      "duels": 68,
      "shooting": 67,
      "defence": 72,
      "passing": 79,
      "skills": 67,
      "average": 71
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/224.jpg",
    "profileYtVideoId": "6ZtUWplIacg",
    "matchYtVideoId": "https://www.youtube.com/watch?v=OIwnKL8Zl5o"
  },
  {
    "draftJersey": 225,
    "role": "DL",
    "name": "Santiago Martínez",
    "foot": "right",
    "height": 170,
    "birthdate": "02/09/2003",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 71,
      "shooting": 65,
      "defence": 76,
      "passing": 86,
      "skills": 73,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/225.jpg",
    "profileYtVideoId": "wTySg9Ak14w",
    "matchYtVideoId": "1HnobK1IRx4"
  },
  {
    "draftJersey": 229,
    "role": "MC",
    "name": "José Miramontes",
    "foot": "left",
    "height": 172,
    "birthdate": "25/01/2000",
    "country": "MEX",
    "macros": {
      "physical": 85,
      "duels": 73,
      "shooting": 86,
      "defence": 81,
      "passing": 78,
      "skills": 73,
      "average": 80
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/229.jpg",
    "profileYtVideoId": "mrL8Jo5Pvsk",
    "matchYtVideoId": "F2tuem2DgKw"
  },
  {
    "draftJersey": 231,
    "role": "DF",
    "name": "Carlos Guedez",
    "foot": "right",
    "height": 175,
    "birthdate": "17/09/1991",
    "country": "VEN",
    "macros": {
      "physical": 80,
      "duels": 56,
      "shooting": 60,
      "defence": 77,
      "passing": 72,
      "skills": 55,
      "average": 70
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/231.jpg",
    "profileYtVideoId": "geLQCDrkUJo",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 232,
    "role": "MC",
    "name": "Carlos Velázquez",
    "foot": "right",
    "height": 175,
    "birthdate": "07/02/2004",
    "country": "MEX",
    "macros": {
      "physical": 72,
      "duels": 58,
      "shooting": 63,
      "defence": 70,
      "passing": 77,
      "skills": 58,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/232.jpg",
    "profileYtVideoId": "qNbhzRBWV5A",
    "matchYtVideoId": "F2tuem2DgKw"
  },
  {
    "draftJersey": 233,
    "role": "MC",
    "name": "José Rivera",
    "foot": "right",
    "height": 184,
    "birthdate": "21/05/2003",
    "country": "MEX",
    "macros": {
      "physical": 75,
      "duels": 68,
      "shooting": 57,
      "defence": 83,
      "passing": 81,
      "skills": 67,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/233.jpg",
    "profileYtVideoId": "g-WOXkCK0sg",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 234,
    "role": "DL",
    "name": "Jerónimo Amione",
    "foot": "left",
    "height": 173,
    "birthdate": "01/04/1990",
    "country": "MEX / LBN",
    "macros": {
      "physical": 86,
      "duels": 67,
      "shooting": 62,
      "defence": 83,
      "passing": 84,
      "skills": 67,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/234.jpg",
    "profileYtVideoId": "rLY61VYOPHg",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 235,
    "role": "DL",
    "name": "Damian Scarinci",
    "foot": "right",
    "height": 173,
    "birthdate": "10/08/1992",
    "country": "MEX / ARG",
    "macros": {
      "physical": 70,
      "duels": 71,
      "shooting": 76,
      "defence": 70,
      "passing": 89,
      "skills": 73,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/235.jpg",
    "profileYtVideoId": "I6q4CCP2Tjk",
    "matchYtVideoId": "b2V0cFApNPU"
  },
  {
    "draftJersey": 236,
    "role": "DF",
    "name": "Patricio González",
    "foot": "left",
    "height": 164,
    "birthdate": "22/10/2004",
    "country": "MEX / USA",
    "macros": {
      "physical": 73,
      "duels": 58,
      "shooting": 59,
      "defence": 67,
      "passing": 76,
      "skills": 58,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/236.jpg",
    "profileYtVideoId": "DHlfntrvew4",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 238,
    "role": "MC",
    "name": "Irving Melgar",
    "foot": "left",
    "height": 170,
    "birthdate": "26/08/2001",
    "country": "MEX / ESP",
    "macros": {
      "physical": 79,
      "duels": 67,
      "shooting": 69,
      "defence": 68,
      "passing": 90,
      "skills": 68,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/238.jpg",
    "profileYtVideoId": "tR6ZODlc_ig",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 239,
    "role": "DL",
    "name": "Fernando Olmedo",
    "foot": "left",
    "height": 172,
    "birthdate": "26/02/2003",
    "country": "MEX / FRA",
    "macros": {
      "physical": 82,
      "duels": 74,
      "shooting": 72,
      "defence": 71,
      "passing": 70,
      "skills": 74,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/239.jpg",
    "profileYtVideoId": "_NLTtGZ7w5o",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 240,
    "role": "DL",
    "name": "Luis González",
    "foot": "left",
    "height": 183,
    "birthdate": "09/02/1997",
    "country": "MEX",
    "macros": {
      "physical": 89,
      "duels": 62,
      "shooting": 57,
      "defence": 84,
      "passing": 74,
      "skills": 62,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/240.jpg",
    "profileYtVideoId": "WmUcoNnkAE0",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 241,
    "role": "DF",
    "name": "David Tamayo",
    "foot": "left",
    "height": 185,
    "birthdate": "03/10/2002",
    "country": "MEX",
    "macros": {
      "physical": 74,
      "duels": 63,
      "shooting": 58,
      "defence": 74,
      "passing": 71,
      "skills": 62,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/241.jpg",
    "profileYtVideoId": "lORJmPr4mkw",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 243,
    "role": "MC",
    "name": "Gustavo Guillen",
    "foot": "left",
    "height": 169,
    "birthdate": "24/09/1993",
    "country": "MEX",
    "macros": {
      "physical": 78,
      "duels": 83,
      "shooting": 90,
      "defence": 88,
      "passing": 90,
      "skills": 84,
      "average": 86
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/243.jpg",
    "profileYtVideoId": "n8fIIfZPSCs",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 244,
    "role": "DL",
    "name": "Ricardo Saldaña",
    "foot": "right",
    "height": 183,
    "birthdate": "25/10/2001",
    "country": "MEX",
    "macros": {
      "physical": 73,
      "duels": 67,
      "shooting": 71,
      "defence": 63,
      "passing": 79,
      "skills": 67,
      "average": 70
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/244.jpg",
    "profileYtVideoId": "U-rYYgRLVZ4",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 245,
    "role": "DL",
    "name": "Juan Celada",
    "foot": "left",
    "height": 187,
    "birthdate": "26/07/1994",
    "country": "MEX",
    "macros": {
      "physical": 83,
      "duels": 88,
      "shooting": 89,
      "defence": 77,
      "passing": 90,
      "skills": 89,
      "average": 87
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/245.jpg",
    "profileYtVideoId": "8KiC3aG_GRI",
    "matchYtVideoId": "Dh-lg9gqz-0"
  },
  {
    "draftJersey": 246,
    "role": "DF",
    "name": "Alejandro Corona",
    "foot": "right",
    "height": 182,
    "birthdate": "13/02/2001",
    "country": "MEX",
    "macros": {
      "physical": 69,
      "duels": 74,
      "shooting": 65,
      "defence": 70,
      "passing": 66,
      "skills": 76,
      "average": 70
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/246.jpg",
    "profileYtVideoId": "eMU7UBnH-NA",
    "matchYtVideoId": "VGSRdaTy3Ao"
  },
  {
    "draftJersey": 248,
    "role": "MC",
    "name": "José Álvarez",
    "foot": "right",
    "height": 180,
    "birthdate": "10/02/2005",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 73,
      "shooting": 69,
      "defence": 71,
      "passing": 82,
      "skills": 74,
      "average": 75
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/248.jpg",
    "profileYtVideoId": "pzZLDd4cZm0",
    "matchYtVideoId": "VGSRdaTy3Ao"
  },
  {
    "draftJersey": 250,
    "role": "DL",
    "name": "Juan Romero",
    "foot": "right",
    "height": 169,
    "birthdate": "10/04/2002",
    "country": "MEX",
    "macros": {
      "physical": 86,
      "duels": 70,
      "shooting": 63,
      "defence": 77,
      "passing": 78,
      "skills": 70,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/250.jpg",
    "profileYtVideoId": "eRJEEPpSdJc",
    "matchYtVideoId": "VGSRdaTy3Ao"
  },
  {
    "draftJersey": 311,
    "role": "MC",
    "name": "Francisco Arce",
    "foot": "right",
    "height": 178,
    "birthdate": "12/3/1998",
    "country": "MEX",
    "macros": {
      "physical": 80,
      "duels": 83,
      "shooting": 65,
      "defence": 73,
      "passing": 77,
      "skills": 85,
      "average": 77
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/311.jpg",
    "profileYtVideoId": "aL17hGgTXho",
    "matchYtVideoId": "https://www.youtube.com/watch?v=y_m3QK10K4M"
  },
  {
    "draftJersey": 314,
    "role": "MC",
    "name": "Lorenzo Abella",
    "foot": "right",
    "height": 173,
    "birthdate": "03/02/2003",
    "country": "MEX / ALE",
    "macros": {
      "physical": 79,
      "duels": 69,
      "shooting": 58,
      "defence": 81,
      "passing": 77,
      "skills": 69,
      "average": 72
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/314.jpg",
    "profileYtVideoId": "uh9NyRXZUuA",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 316,
    "role": "MC",
    "name": "Erick Guzmán",
    "foot": "left",
    "height": 165,
    "birthdate": "15/07/1994",
    "country": "MEX",
    "macros": {
      "physical": 82,
      "duels": 84,
      "shooting": 65,
      "defence": 91,
      "passing": 90,
      "skills": 86,
      "average": 83
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/316.jpg",
    "profileYtVideoId": "dnqGHxuhFW0",
    "matchYtVideoId": "https://www.youtube.com/watch?v=dOXzJxysnW4"
  },
  {
    "draftJersey": 317,
    "role": "MC",
    "name": "Jonathan Ontiveros",
    "foot": "right",
    "height": 174,
    "birthdate": "20/02/1998",
    "country": "MEX",
    "macros": {
      "physical": 83,
      "duels": 67,
      "shooting": 52,
      "defence": 74,
      "passing": 71,
      "skills": 69,
      "average": 69
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/317.jpg",
    "profileYtVideoId": "-CKPWGtgYaE",
    "matchYtVideoId": "FzTLAKVVqIc"
  },
  {
    "draftJersey": 318,
    "role": "MC",
    "name": "Javier Meraz",
    "foot": "left",
    "height": 172,
    "birthdate": "17/09/1999",
    "country": "MEX",
    "macros": {
      "physical": 81,
      "duels": 70,
      "shooting": 72,
      "defence": 75,
      "passing": 74,
      "skills": 70,
      "average": 74
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/318.jpg",
    "profileYtVideoId": "Dsb9Atb6WjA",
    "matchYtVideoId": "EazXl7HgXIg"
  },
  {
    "draftJersey": 319,
    "role": "MC",
    "name": "Santiago Pérez",
    "foot": "left",
    "height": 163,
    "birthdate": "30/05/2003",
    "country": "MEX",
    "macros": {
      "physical": 75,
      "duels": 73,
      "shooting": 65,
      "defence": 78,
      "passing": 78,
      "skills": 73,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/319.jpg",
    "profileYtVideoId": "RQaGJDXzs7I",
    "matchYtVideoId": "https://www.youtube.com/watch?v=_hSNDu_vKG4"
  },
  {
    "draftJersey": 320,
    "role": "MC",
    "name": "Israel Jiménez",
    "foot": "right",
    "height": 174,
    "birthdate": "13/08/1989",
    "country": "MEX",
    "macros": {
      "physical": 88,
      "duels": 64,
      "shooting": 58,
      "defence": 94,
      "passing": 90,
      "skills": 66,
      "average": 76
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/320.jpg",
    "profileYtVideoId": "ZVp1cHZEtBY",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": 321,
    "role": "MC",
    "name": "Luis García",
    "foot": "right",
    "height": 170,
    "birthdate": "20/04/2001",
    "country": "MEX",
    "macros": {
      "physical": 71,
      "duels": 75,
      "shooting": 70,
      "defence": 71,
      "passing": 72,
      "skills": 77,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/321.jpg",
    "profileYtVideoId": "4J2RLYjk0Kg",
    "matchYtVideoId": "YZPacpzHqpY"
  },
  {
    "draftJersey": 322,
    "role": "MC",
    "name": "Jhonatan García",
    "foot": "right",
    "height": 173,
    "birthdate": "21/03/1999",
    "country": "MEX",
    "macros": {
      "physical": 76,
      "duels": 65,
      "shooting": 65,
      "defence": 68,
      "passing": 65,
      "skills": 66,
      "average": 67
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/322.jpg",
    "profileYtVideoId": "UB8zVTROe3I",
    "matchYtVideoId": "SxWaaHUpmZQ"
  },
  {
    "draftJersey": 329,
    "role": "MC",
    "name": "Rodrigo Ulibarri",
    "foot": "left",
    "height": 177,
    "birthdate": "06/08/1992",
    "country": "MEX",
    "macros": {
      "physical": 66,
      "duels": 70,
      "shooting": 72,
      "defence": 53,
      "passing": 76,
      "skills": 70,
      "average": 68
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/329.jpg",
    "profileYtVideoId": "YnbTSGFsHUM",
    "matchYtVideoId": "no jugó partido (lesión)"
  },
  {
    "draftJersey": 330,
    "role": "MC",
    "name": "Luis Cárdenas",
    "foot": "left",
    "height": 165,
    "birthdate": "07/07/1996",
    "country": "MEX",
    "macros": {
      "physical": 69,
      "duels": 74,
      "shooting": 67,
      "defence": 75,
      "passing": 79,
      "skills": 74,
      "average": 73
    },
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft-am/330.jpg",
    "profileYtVideoId": "zlu2-aOwD9w",
    "matchYtVideoId": ""
  }
]
